/*
  POUFF homepage gate (sections/pouff-homepage-gate.liquid).
  Validates the email, subscribes it to the Klaviyo list via the public client
  API (and records an "Early Access Signup" event for the welcome flow), then swaps the form for the thank-you message
  and a "Shop now" button. Signing up by itself does NOT unlock the site; the private link does, whether it comes from
  the email or from that button: /?access=CODE stores CODE in the cart
  attribute early_access, and theme.liquid lets the visitor past the gate when it
  matches the "Private access code" theme setting. Since 2026-10-20 the "Shop now" button carries the code in this
  page's markup (see the note in sections/pouff-homepage-gate.liquid).
*/
(function () {
  var root = document.querySelector('[data-pouff-gate]');
  if (!root) return;

  var form = root.querySelector('[data-pouff-gate-form]');
  var input = form.querySelector('input[type="email"]');
  var button = form.querySelector('button[type="submit"]');
  var errorEl = root.querySelector('[data-pouff-gate-error]');
  var doneEl = root.querySelector('[data-pouff-gate-done]');
  var fineEl = root.querySelector('.pouff-gate__fine');
  var companyId = root.getAttribute('data-company');
  var listId = root.getAttribute('data-list');
  var busy = false;

  // Private-link unlock ------------------------------------------------------
  var STORE_KEY = 'pouff_early_access';
  var TRIED_KEY = 'pouff_early_access_tried';
  function safe(fn) { try { return fn(); } catch (e) { return null; } }

  var params = new URLSearchParams(window.location.search);
  var urlCode = params.get('access');
  var code = urlCode || safe(function () { return localStorage.getItem(STORE_KEY); });
  if (code) {
    var tried = safe(function () { return sessionStorage.getItem(TRIED_KEY); });
    if (tried === code) {
      // Already tried this session and the gate is still here: the code is wrong or expired.
      safe(function () { localStorage.removeItem(STORE_KEY); });
      if (urlCode) {
        var msg = root.querySelector('[data-pouff-gate-error]');
        if (msg) { msg.textContent = 'That private link has expired. Pop your email in and we will send a fresh one.'; msg.hidden = false; }
      }
    } else {
      safe(function () { sessionStorage.setItem(TRIED_KEY, code); });
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { early_access: code } })
      }).then(function (res) {
        if (!res.ok) throw new Error('cart');
        safe(function () { localStorage.setItem(STORE_KEY, code); });
        params.delete('access');
        var qs = params.toString();
        window.location.replace(window.location.pathname + (qs ? '?' + qs : ''));
      }).catch(function () { /* stay on the gate */ });
    }
  }

  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  var GENERIC_ERROR = "That didn't go through. Try again in a moment.";

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = !msg;
  }

  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Homepage gate',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('klaviyo');
    });
  }

  // Records an "Early Access Signup" event every time the form is submitted. Subscribing alone does
  // nothing for someone who is already on the list, so the welcome flow triggers on this event instead
  // of "added to list". Fire-and-forget: a failure here must never block the thank-you message.
  function trackSignup(email) {
    try {
      fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { source: 'Homepage gate' },
              metric: { data: { type: 'metric', attributes: { name: 'Early Access Signup' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      }).catch(function () {});
    } catch (err) {}
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var email = input.value.trim();
    if (!EMAIL_RE.test(email)) {
      showError('That email looks off. Try again?');
      input.focus();
      return;
    }
    showError('');
    busy = true;
    button.disabled = true;
    button.textContent = '\u2026';
    subscribe(email).then(function () {
      trackSignup(email);
      form.hidden = true;
      form.style.display = 'none';
      if (fineEl) fineEl.hidden = true;
      doneEl.hidden = false;
    }, function () {
      busy = false;
      button.disabled = false;
      button.textContent = button.getAttribute('data-label');
      showError(GENERIC_ERROR);
    });
  });

  input.addEventListener('input', function () { showError(''); });
})();
